"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OsanoEvent = exports.OsanoConsentDecision = exports.OsanoConsentType = void 0;
/* simplified Osano interface base on https://github.com/input-output-hk/gdpr-test/blob/90b6e3696b905bc5f2d17364b820ac859060db83/src/helpers/osano-adapter.ts */
var OsanoConsentType;
(function (OsanoConsentType) {
    OsanoConsentType["ESSENTIAL"] = "ESSENTIAL";
    OsanoConsentType["STORAGE"] = "STORAGE";
    OsanoConsentType["MARKETING"] = "MARKETING";
    OsanoConsentType["PERSONALIZATION"] = "PERSONALIZATION";
    OsanoConsentType["ANALYTICS"] = "ANALYTICS";
    OsanoConsentType["OPT_OUT"] = "OPT_OUT";
})(OsanoConsentType || (exports.OsanoConsentType = OsanoConsentType = {}));
var OsanoConsentDecision;
(function (OsanoConsentDecision) {
    OsanoConsentDecision["ACCEPT"] = "ACCEPT";
    OsanoConsentDecision["DENY"] = "DENY";
})(OsanoConsentDecision || (exports.OsanoConsentDecision = OsanoConsentDecision = {}));
var OsanoEvent;
(function (OsanoEvent) {
    OsanoEvent["CONSENT_SAVED"] = "osano-cm-consent-saved";
})(OsanoEvent || (exports.OsanoEvent = OsanoEvent = {}));
